import { Link, withPrefix } from 'gatsby';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { IconContext } from 'react-icons';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

import { useGlobalState } from '~app/state';

const NavigationStyles = styled.div`
  display: grid;
  grid-template-columns: 45px 1fr 45px;
  padding-top: 0;
  align-items: center;
  margin-bottom: 16px;

  .navigation__items-wrapper {
    // height: 115px;
    height: 117px;
    overflow: hidden;
    // border: 1px solid red;
  }

  .navigation__items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    align-items: start;
    padding-top: 24px;
    padding-bottom: 24px;

    &.selected-row-1 {
        position: relative;
        // top: 0;
        top: -20px;
    }

    &.selected-row-2 {
        position: relative;
        // top: -105px;
        top: -147px;
    }

    &.selected-row-3 {
        position: relative;
        // top: -232px;
        // top: -224px;
        top: -277px;
    }
  }

  .navigation__image {
    width: 50px;
    max-height: 50px;
    justify-self: center;

    &.navigation__image-thomas-matsuda {
      width: auto;
      // height: 45px;
    }
  }

  .test-left,
  .test-right {
    // border: 1px solid red;
  }

  .navigation__arrow-left,
  .navigation__arrow-right {
    justify-self: center;
    background: none;
    border: none;
    padding: 0;
  }

  .navigation__item {
    text-align: center;
    display: grid;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: none;
    text-decoration: none;

    &:active,
    &:hover {
      .navigation__title {
        border-bottom: 5px solid #000;
      }
    }
  }
  
  .item-5,
  .item-6,
  .item-7,
  .item-8,
  .item-9 {
    // display: none;
  }

  .navigation__title {
    font-weight: 700;
    font-family: Benton;
    font-size: 12px;
    line-height: 1.2;
    letter-spacing: 0.25px;
    // width: 85%;
    margin: 0 auto;
    margin-top: 16px;
    color: #000;
    border-bottom: 5px solid transparent;
    padding-bottom: 8px;
    cursor: pointer;
  }

  .fa-angle-left,
  .fa-angle-right {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    margin-bottom: 24px;

    .navigation__items-wrapper {
      // height: 107px;
      // height: 98px;
      // height: 102px;
      // height: 92px;
    }

    .navigation__items {
      grid-row-gap: 24px;

      &.selected-row-1 {
          position: relative;
          // top: -110px;
          // top: -20px;
      }

      &.selected-row-2 {
          position: relative;
          // top: -120px;
          // top: -86px;
          // top: -140px;
          // top: -145px;
          top: -135px;
      }

      &.selected-row-3 {
          position: relative;
          // top: -208px;
          // top: -190px;
          // top: -218px;
          // top: -248px;
          // top: -258px;
          // top: -260px;
          top: -255px;
      }
    }
  }

  @media (max-width: 725px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -208px;
          // top: -190px;
          // top: -188px;
          top: -265px;
      }
    }
  }

  @media (max-width: 700px) {
    .navigation__items {
      &.selected-row-2 {
          position: relative;
          // top: -110px;
          // top: -95px;
      }

      &.selected-row-3 {
          position: relative;
          // top: -208px;
          // top: -190px;
          // top: -188px;
          // top: -265px;
      }
    }
  }

  @media (max-width: 640px) {
    .navigation__items {
      grid-column-gap: 16px;

      &.selected-row-3 {
          position: relative;
          // top: -227px;
      }
    }
  }

  @media (max-width: 525px) {
    .navigation__items {
      &.selected-row-3 {
          position: relative;
          // top: -227px;
          // top: -268px;
          top: -285px;
      }
    }
  }

  @media (max-width: 500px) {
    .navigation__items {

      &.selected-row-3 {
          position: relative;
          // top: -285px;
      }
    }
  }
  
  @media (max-width: 480px) {
    padding: 0;
    grid-template-columns: 32px 1fr 32px;

    .navigation__items {
      grid-column-gap: 12px;
      grid-template-columns: repeat(3, 1fr);

      &.selected-row-3 {
          position: relative;
          top: -270px;
      }
    }

    .fa-angle-left,
    .fa-angle-right {
      height: 32px;
      width: 32px;
    }
  }

  @media (max-width: 400px) {

    .navigation__items {
      // grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 4px;
    }

    .navigation__title {
      width: 100%;
    }
  }
`;

const Navigation = ({ data, selectedMonument }) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [activeMonument, setActiveMonument] = useState(null);
  const [navigationWidth, setNavigationWidth] = useState();
  const NavigationRef = useRef();

  const advanceSlider = useCallback(() => {
    setSelectedRow(selectedRow + 1);
  }, [selectedRow]);

  const rewindSlider = useCallback(() => {
    setSelectedRow(selectedRow - 1);
  }, [selectedRow]);

  // In your setMonumentActive, you pluck the value of that data attribute and setActiveMonument to that value.
  const setMonumentActive = useCallback((event) => {
    const hoveredMonument = event.target.getAttribute('data-monument');
    setActiveMonument(hoveredMonument);
  }, []);

  const setMonumentInactive = useCallback((event) => {
    setActiveMonument(null);
  }, []);


  let selectedIndex;

  const navigationList = data.nodes.map((link, index) => {
    const navigationID = `navigation__item item-${link.order} ${selectedMonument === link.slug ? 'navigation__item-selected' : ''}`;
    const navigationTitle = `${link.sculpture}`;

    if (selectedMonument === link.slug) {
      selectedIndex = index;
    }

    const navigationImage = `navigation__image navigation__image-${link.slug}`;
    const navigationImagePrimary = `images/Silo_${link.slug}1.png`;
    const navigationImageSecondary = `images/Silo_${link.slug}2.png`;

    return (
      <Link
        className={navigationID}
        key={link.slug}
        to={`/${link.slug}`}
        as="button"
        onMouseEnter={(event) => setMonumentActive(event)}
        onMouseLeave={(event) => setMonumentInactive(event)}
        data-monument={link.slug}
      >
        <img 
          src={selectedMonument === link.slug 
          || activeMonument === link.slug
          ? withPrefix(navigationImageSecondary)
          : withPrefix(navigationImagePrimary)} 
          className={navigationImage} 
          alt={navigationTitle}
          data-monument={link.slug}
        />
        <div 
          className="navigation__title"
          data-monument={link.slug}
        >{navigationTitle}</div>
      </Link>
    );
  });

  // USE EFFECT HOOKS
  // you can have multiple useEffect hooks. Each one will run whenever the component mounts
  // or whenever any of the values in the dependency array at the end of the function changes

  // Potential fix to Image undefined issue
  useEffect(() => {
    data.nodes.forEach((link) => {
      const navigationImageSecondary = `images/Silo_${link.slug}2.png`;

      const preloadSecondary = new Image();
      preloadSecondary.src = withPrefix(navigationImageSecondary);
    });
  }, []);

  // this hook handles getting and setting the state value for the navigation element width
  useEffect(() => {
    // updates the value of navigationWidth in state
    function updateNavWidth() {
      setNavigationWidth(NavigationRef.current.offsetWidth);
    }

    // once the navigation element mounts, the current property of NavigationRef will
    // no longer be undefined, so we can get the initial width of the element,
    // set it in state, and set up an event listener
    // to re-set the value in state when the window resizes
    if (NavigationRef.current) {
      setNavigationWidth(NavigationRef.current.offsetWidth);
      window.addEventListener('resize', updateNavWidth);
    }
    // cleans up the event listener
    return (_) => {
      window.removeEventListener('resize', updateNavWidth);
    };
    // the NavigationRef is in the dependency array, so this useEffect hook
    // reruns whenever this changes. So, initially it's undefined, but
    // it gets set when the component mounts, so the hook runs again then
  }, [NavigationRef]);

  // this useEffect hook contains only navigationWidth in the dependency array
  // so it runs initially, when the component mounts, and again when the above
  // useEffect hook sets navigationWidth and every other time navigationWidth changes
  useEffect(() => {
    if (navigationWidth) {
      if (navigationWidth !== undefined && navigationWidth < 480) {
        if (selectedIndex < 3 || selectedIndex === undefined) {
          setSelectedRow(1);
        } else if (selectedIndex < 6) {
          setSelectedRow(2);
        } else {
          setSelectedRow(3);
        }
      } else if (selectedIndex < 4 || selectedIndex === undefined) {
        setSelectedRow(1);
      } else if (selectedIndex < 8) {
        setSelectedRow(2);
      } else {
        setSelectedRow(3);
      }
    }
  }, [navigationWidth]);

  return (
    <NavigationStyles ref={NavigationRef}>
      <div className="test-left">
      <IconContext.Provider value={{ size: "40px", className: "fa-angle-left" }}>
        {selectedRow > 1 && (
          <button 
            className="navigation__arrow-left"
            onClick={() => rewindSlider()}
            type="button"
          >
            <FaAngleLeft />
          </button>
        )}
      </IconContext.Provider>
      </div>

      <div className="navigation__items-wrapper">
        {selectedRow !== undefined && navigationWidth && (
          <div className={`navigation__items selected-row-${selectedRow}`}>
            {navigationList}
          </div>
        )}
      </div>

      <div className="test-right">
      <IconContext.Provider value={{ size: '40px', className: 'fa-angle-right' }}>
        {selectedRow < 3 && (
          <button 
            className="navigation__arrow-right"
            onClick={() => advanceSlider()}
            type="button"
          >
            <FaAngleRight />
          </button>
        )}

      </IconContext.Provider>
      </div>
    </NavigationStyles>
  );
};

export default Navigation;